import * as React from "react";
import Box from "@mui/material/Box";
import BottomNavigation from "@mui/material/BottomNavigation";
import "../../App.css";
import { BottomNavigationAction, Paper } from "@mui/material";
import { colors } from "../../utils/colors";

export default function FixedBottomNavigation(): React.JSX.Element {
  const ref = React.useRef<HTMLDivElement>(null);

  return (
    <Box sx={{ pb: 7 }} ref={ref}>
      <Paper
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          boxShadow: "none",
        }}
        elevation={10}
      >
        <BottomNavigation
          showLabels
          sx={{
            backgroundColor: colors.cardBackground,
            minHeight: "60px",
            color: colors.secondaryText,
            alignItems: "center",
          }}
        >
          <BottomNavigationAction
            label="Yard Manager Beta 2025"
            sx={{ fontFamily: "SigmaSans" }}
          />
        </BottomNavigation>
      </Paper>
    </Box>
  );
}
